import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import { apiClient } from '../apiClient';
import type { ILead } from '../types/lead';
import type { IRequestException } from '../types/requestException';

interface ILeadProps {
    id: number;
}

export interface IGetLeadProps
    extends UseQueryOptions<ILead, IRequestException>,
        ILeadProps {}

const getLead = async ({ id }: ILeadProps) => {
    const response = await apiClient.get(`property-leads/${id}`);
    return (await response.json()) as ILead;
};

export const useGetLeadQuery = ({ id, ...options }: IGetLeadProps) => {
    return useQuery<ILead, IRequestException>(
        ['property-lead', { id }],
        async () => await getLead({ id }),
        {
            ...options,
        }
    );
};
